import CloseIcon from './Close'
import EditIcon from './Edit'
import LockedIcon from './Locked'
import PdfIcon from './Pdf'
import RefreshIcon from './Refresh'
import UnlockedIcon from './Unlocked'
import QrCodeIcon from './QrCode'
import MatrixIcon from './Matrix'
import ReturnPageIcon from './ReturnPageButton'

export {
  CloseIcon,
  EditIcon,
  LockedIcon,
  PdfIcon,
  RefreshIcon,
  UnlockedIcon,
  QrCodeIcon,
  MatrixIcon,
  ReturnPageIcon
}



// WEBPACK FOOTER //
// ./src/components/icons/index.js